<script>
export default {
  name: 'HomeIconSVG'
};
</script>

<template>
  <svg id="Icon_-_navigation_-_home-outline" data-name="Icon - navigation - home-outline" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path id="home-outline" d="M10.746,5.249l4.373,3.762V15.54H13.37V10.524H8.122V15.54H6.373V9.011l4.373-3.762m0-2.249L2,10.524H4.624v6.688H9.871V12.2h1.749v5.016h5.248V10.524h2.624" transform="translate(-0.746 0.394)" fill="#4d4d4d"/>
    <g id="Boundary" fill="none" stroke="#707070" stroke-width="1" opacity="0.005">
      <rect width="20" height="20" stroke="none"/>
      <rect x="0.5" y="0.5" width="19" height="19" fill="none"/>
    </g>
  </svg>
</template>
